import { render, staticRenderFns } from "./LiveRanking.vue?vue&type=template&id=066e6754&scoped=true&"
import script from "./LiveRanking.vue?vue&type=script&lang=js&"
export * from "./LiveRanking.vue?vue&type=script&lang=js&"
import style0 from "./LiveRanking.vue?vue&type=style&index=0&id=066e6754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066e6754",
  null
  
)

export default component.exports